module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-56-20-537.f81c3205.mp4";